import { PATHS } from "../config/permissionsPaths";
import routes from "./routes";

export const ROUTE_PERMISSIONS = {
  [routes.home]: PATHS.INICIO,
  [routes.calculadora]: PATHS.CALCULADORAS,
  [routes.baseDocumental]: PATHS.BASE_DOCUMENTAL,
  [routes.enlaces]: PATHS.ENLACES,
  [routes.resultados]: PATHS.RESULTADOS,
  [routes.maestro]: PATHS.MAESTROS,
  [routes.informe]: PATHS.REPORTES,
  [routes.reportesNormativos]: PATHS.REPORTES,
  [routes.dashboard]: PATHS.INDICADORES,
  [routes.indicadorGubernamental]: PATHS.INDICADOR_GUBERNAMENTAL,
  [routes.paiRegistro]: PATHS.REGISTRO_PAI,
  [routes.planParto]: PATHS.PLAN_PARTO,
  [routes.citologia]: PATHS.GESTIONAR_CITOLOGIA,
  [routes.carguePacientesMasivos]: PATHS.CARGUE_PACIENTE_MASIVO,
  [routes.soporte]: PATHS.SOPORTE_TECNICO,
  [routes.logsServicios]: PATHS.VER_LOGS_SINCRONIZADOR,

  "menu:buscar_paciente": PATHS.ARCHIVO,
  "menu:asignar_grupo": PATHS.ARCHIVO,
  "menu:exportar_caso": PATHS.EXPORTAR_CASO,
  "menu:exportar_pdf": PATHS.ARC_EXPORTAR_PDF || PATHS.EXPORTAR_CASO,
  "menu:exportar_csv": PATHS.ARC_EXPORTAR_CSV || PATHS.EXPORTAR_CASO,
  "menu:configuracion": PATHS.CONFIGURACION,
  "menu:cargar_datos": PATHS.CARGAR_DATOS_MASIVOS,
  "menu:registros": PATHS.REGISTROS,
  "menu:analitica": PATHS.ANALITICA,
  "menu:herramientas": PATHS.HERRAMIENTAS,
  "menu:reportes": PATHS.REPORTES,
  "menu:ayuda": PATHS.AYUDA,
};
